type ApiFieldErrors = Record<string, string[]>;
type ApiErrorShape =
	| { code: number; errors?: string[] }
	| { code: number; errors: { errors: ApiFieldErrors } };

type ApiResult<T> = T | ApiErrorShape;

function isApiError(x: any): x is ApiErrorShape {
	return x && typeof x === 'object' && 'code' in x && Number(x.code) >= 400;
}

export function extractErrorMessage(err: ApiErrorShape): string {
	if (Array.isArray((err as any)?.errors) && (err as any).errors[0]) {
		return (err as any).errors[0];
	}
	return 'Something went wrong';
}

export function handleResponseErrors<T>(result: ApiResult<T>): T {
	if (isApiError(result)) {
		const message = extractErrorMessage(result);
		const e = new Error(message);
		(e as any).code = result.code;
		throw e;
	}
	return result as T;
}

// export function handleResponseErrors<T>(result: ApiResult<T>): {
// 	isSucceeded: boolean;
// 	data?: T;
// 	error?: { code: number; message: string };
// } {
// 	if (isApiError(result)) {
// 		return {
// 			isSucceeded: false,
// 			error: {
// 				code: result.code,
// 				message: extractErrorMessage(result),
// 			},
// 		};
// 	}

// 	return {
// 		isSucceeded: true,
// 		data: result as T,
// 	};
// }
